// LessonsSection.js
import React from "react";
import LessonCard from "./LessonCard";
const LessonsSection = () => {
  const lessons = [
    {
      id: 1,
      title: "ID card generator",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837829/React30/20231126_135216_0000_rbuh7z.jpg",
      description:
        "In this article, we’ll walk through the process of creating an ID card generator using Vanilla JavaScript",
      articleLink:
        "https://smhatre59.medium.com/react30-project-1-id-card-generator-58f615ed80af"
    },
    {
      id: 2,
      title: "Building a Clicker App",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837830/React30/20231126_135216_0001_aak8mj.jpg",
      description:
        "In this tutorial, we'll build a simple clicker app using useState hook in React.js",
      articleLink:
        "https://medium.com/@smhatre59/react-30-project-2-building-a-clicker-app-with-react-js-79831b1ae037"
    },
    {
      id: 3,
      title: "Building a Digital Clock App",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837830/React30/20231126_135217_0002_zumpba.jpg",
      description:
        "In this tutorial, we'll create a simple digital clock app using useEffect in React.js",
      articleLink:
        "https://smhatre59.medium.com/react-30-project-3-building-a-digital-clock-app-with-react-js-3b198962e92c"
    },
    {
      id: 4,
      title: "User Feed App",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837830/React30/20231126_135217_0003_ud23pz.jpg",
      description:
        "In this tutorial, we’ll create a user feed app using React.js. We’ll make an API request using Axios to fetch user data and display it as a scrollable feed on the page. This project will help us understand how to use the useEffect hook to make API calls in React applications.",
      articleLink:
        "https://smhatre59.medium.com/react-30-project-4-building-a-user-feed-app-with-react-js-d73c55e38448"
    },
    {
      id: 5,
      title: "Image Gallery App",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837831/React30/20231126_135217_0004_o8c7xb.jpg",
      description:
        "In this tutorial, we’ll create an image gallery app using React.js. We’ll make an API request using Axios to fetch a list of images and display them as a scrollable gallery on the page.",
      articleLink:
        "https://smhatre59.medium.com/react30-project5-building-an-image-gallery-app-with-react-js-2f1095043561"
    },
    {
      id: 6,
      title: "Quote Generation API",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837831/React30/20231126_135217_0005_qrkpwj.jpg",
      description:
        "In this tutorial, we’ll create a backend API for generating quotes using Express.js. We’ll start by using local JSON data, and later replace it with data from a MongoDB database.",
      articleLink:
        "https://smhatre59.medium.com/react30-project-6-building-a-quote-generation-api-with-express-js-8d2cff258742"
    },
    {
      id: 7,
      title: "Random Quote Generator with Redux Toolkit",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837830/React30/20231126_135217_0006_ivohmb.jpg",
      description:
        "In this tutorial, we’ll create a random quote generator using React.js, Redux Toolkit, and Redux Thunk. We’ll also learn how to use the useEffect hook to make API calls.",
      articleLink:
        "https://smhatre59.medium.com/react30-project-7-building-a-random-quote-generator-with-react-js-redux-toolkit-and-redux-thunk-7d68a689433e"
    },
    {
      id: 8,
      title: "Navbar using React Router",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837831/React30/20231126_135217_0007_gkjw0i.jpg",
      description:
        "In this tutorial, we’ll create a navbar using React.js and React Router to navigate between different pages.",
      articleLink:
        "https://smhatre59.medium.com/react30-project-8-building-a-navbar-using-react-router-6910ab5a0268"
    },
    {
      id: 9,
      title: "User authentication using Express.js and MongoDB",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837832/React30/20231126_135217_0008_b9dcoi.jpg",
      description:
        "In this tutorial, we’ll create a backend APIs for implementing user login/registration process using Express.js and MongoDB. We will learn how session creation works and how to validate user data on backend.",
      articleLink:
        "https://smhatre59.medium.com/react30-project-9-building-backend-apis-for-user-authentication-using-express-js-and-mongodb-f28afd29cca6"
    },
    {
      id: 10,
      title: "User Authentication Forms in Frontend",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837833/React30/20231126_135217_0009_aygqhk.jpg",
      description:
        "In this tutorial, we’ll create login and registration forms using React.js and React Router to handle user authentication in frontend.",
      articleLink:
        "https://smhatre59.medium.com/react-30-project-10-building-user-authentication-forms-using-react-js-and-react-router-1e3f2efa0c3a"
    },
    {
      id: 11,
      title: "Cryptocurrency Listing App",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837835/React30/20231126_135217_0010_iu1289.jpg",
      description:
        "In this tutorial, we’ll create a Cryptocurrency listing app using React.js. We’ll learn how to use the render table from JSON array fetched from API call.",
      articleLink:
        "https://smhatre59.medium.com/react30-project-11-building-a-cryptocurrency-listing-app-bd21e8f09854"
    },
    {
      id: 12,
      title: "Instagram Stories Feed",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837835/React30/20231126_135217_0011_yvvdnh.jpg",
      description:
        "In this tutorial, we’ll create a Instagram Stories Feed using React.js. We’ll learn how to use the render categories grid and show stories with text to users.",
      articleLink:
        "https://smhatre59.medium.com/react30-part-12-building-instagram-stories-feed-using-react-js-1902463aa5a9"
    },
    {
      id: 13,
      title: "SpaceX Launch Info app",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837834/React30/20231126_135217_0012_s3rrj3.jpg",
      description:
        "In this tutorial, we’ll build a SpaceX latest launch info app using React. The app will fetch data from the SpaceX API and display launch information along with a video player using the react-player npm package.",
      articleLink:
        "https://smhatre59.medium.com/react30-project-13-spacex-launch-info-app-3659392af5f6"
    },
    {
      id: 14,
      title: "Building Charts Visualisation",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837835/React30/20231126_135217_0013_mqim6f.jpg",
      description:
        "In this tutorial, we’ll build a React app that fetches India’s GDP data from the World Bank API and visualizes it using bar and area charts. We’ll use the axios library for API requests and the recharts npm package for chart visualization.",
      articleLink:
        "https://smhatre59.medium.com/react30-project14-building-charts-visualisation-using-react-js-6bcb140bc6d5"
    },
    {
      id: 15,
      title: "Building Developer Portfolio",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837836/React30/20231126_135217_0014_jcywxn.jpg",
      description:
        "In this tutorial, we’ll build an online developer portfolio using React.js. We’ll take the static site resume code from the Start Bootstrap repository and convert the static HTML code to JSX for rendering in React. This will allow us to leverage the benefits of React’s component-based architecture for creating a dynamic and interactive developer portfolio.",
      articleLink:
        "https://smhatre59.medium.com/react-30-project-15-building-developer-portfolio-using-react-js-03e59f45f177"
    },
    {
      id: 16,
      title: "Implementing Theme Switching",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837838/React30/20231126_135217_0015_u58stc.jpg",
      description:
        "In this tutorial, we’ll walk through the process of implementing theme switching (Dark theme/Light theme) in a basic web app using React and Bootstrap. We’ll use the useContext hook to manage the theme state, providing a seamless user experience with the ability to switch between different themes.",
      articleLink:
        "https://smhatre59.medium.com/react30-project-16-implementing-theme-switching-in-a-react-web-app-9f59279ea5ed"
    },
    {
      id: 17,
      title: "Implementing React Query",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837839/React30/20231126_135217_0016_o75p1d.jpg",
      description:
        "In this tutorial, we’ll explore how to integrate React Query into a basic web app.",
      articleLink:
        "https://smhatre59.medium.com/react30-project-17-implementing-react-query-in-a-web-app-c6931895ea0a"
    },
    {
      id: 18,
      title: "Shopping cart app by utilising useReducer hook",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837838/React30/20231202_211851_0000_esekzx.jpg",
      description:
        "In this tutorial, we’ll create a simple Shopping Cart application demonstrating how useReducer simplifies state updates.",
      articleLink:
        "https://smhatre59.medium.com/react30-project-18-shopping-cart-app-by-utilising-usereducer-hook-c9580d037d2d"
    },
    {
      id: 19,
      title: "Implementing Lazy Loading in React using Suspense API",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837840/React30/20231205_083538_0000_mgnkee.png",
      description:
        "In this tutorial, we'll guide you through building a practical mini project that incorporates lazy loading using React's Suspense API.",
      articleLink:
        "https://smhatre59.medium.com/react30-project-19-implementing-lazy-loading-in-react-using-suspense-api-acaa607d6375"
    },
    {
      id: 20,
      title: "Building a Game Release Website with Styled Components",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837840/React30/20231208_175909_0000_qmeapv.jpg",
      description:
        "In this article, we'll guide you through the process of building a game release website using React and adding style to your components with the powerful Styled Components library.",
      articleLink:
        "https://smhatre59.medium.com/react30-project-20-building-a-game-release-website-with-styled-components-253927074725"
    },
    {
      id: 21,
      title: "Building a Text-Only Social Media Website with useMemo",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837841/React30/20231211_130532_0000_g8vzml.jpg",
      description:
        "In this guide, we’ll explore the process of building a text-only social media website using React. To optimize performance, we’ll leverage the useMemo hook for efficient memoization of data.",
      articleLink:
        "https://smhatre59.medium.com/react30-project21-building-a-text-only-social-media-website-with-usememo-in-react-29d9ec797867"
    },
    {
      id: 22,
      title: "Building a Job Portal with useCallback",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837841/React30/20231216_144659_0000_pxd15s.jpg",
      description:
        "In this article, we’ll explore the process of building a job portal using React and optimizing its performance with the useCallback hook.",
      articleLink:
        "https://smhatre59.medium.com/react30-project22-building-a-job-portal-with-usecallback-in-react-d8305bcc5c5a"
    },
    {
      id: 23,
      title: "Setting Up a React Project Using Webpack and Babel",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837842/React30/20231222_233940_0000_j4bqi0.jpg",
      description:
        "In this tutorial, we’ll guide you through the process of setting up a React project using Webpack and Babel from scratch.",
      articleLink:
        "https://smhatre59.medium.com/react30-project23-setting-up-a-react-project-using-webpack-and-babel-f4ca5554dfec"
    },
    {
      id: 24,
      title: "Writing test cases with react-testing-library",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837842/React30/20231223_104200_0000_pli0do.jpg",
      description:
        "In this tutorial, we will set up and use react testing library for writing test cases in react",
      articleLink:
        "https://smhatre59.medium.com/writing-test-cases-with-react-testing-library-12e1e1db8993"
    },
    {
      id: 25,
      title: "Simulating user interactions with react-testing-library",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837842/React30/20231223_104200_0000_pli0do.jpg",
      description:
        "In this tutorial, we will set up and use react testing library for writing test cases in react",
      articleLink:
        "https://smhatre59.medium.com/writing-test-cases-with-react-testing-library-12e1e1db8993"
    },
    {
      id: 26,
      title: "Mocking data in API calls using react-testing-library",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837844/React30/20231223_105238_0000_ogvotb.jpg",
      description: "In this guide, we’ll cover how to mock API calls",
      articleLink:
        "https://smhatre59.medium.com/mocking-data-in-api-calls-using-react-testing-library-61d756a49675"
    },
    {
      id: 27,
      title: "Building a Home Decor Website with Material-UI",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837845/React30/20231231_125109_0000_vbx0jn.jpg",
      description:
        "In this article, we’ll explore how to build a home decor website using Material-UI in React.",
      articleLink:
        "https://smhatre59.medium.com/react30-project27-building-a-home-decor-website-with-material-ui-in-react-b8b008b5af1b"
    },
    {
      id: 28,
      title: "Building a VR Headset Launch Website with Tailwind CSS",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837845/React30/20240111_165847_0000_ncxqnb.jpg",
      description:
        "In this article, we’ll explore the creation of a VR headset launch website using Tailwind CSS in a React application.",
      articleLink:
        "https://smhatre59.medium.com/react30-project28-building-a-vr-headset-launch-website-with-tailwind-css-in-react-3a09434c0e9a"
    },
    {
      id: 29,
      title: "Building a Markdown Editor",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837846/React30/20240114_152345_0000_owdt8w.jpg",
      description:
        "In this article, we’ll explore the steps to build a Markdown editor website in a React application",
      articleLink:
        "https://smhatre59.medium.com/react30-project29-building-a-markdown-editor-in-react-7f51cd0af635"
    },
    {
      id: 30,
      title: "Building an Image Recognition App using TensorflowJS",
      image:
        "https://res.cloudinary.com/dk22rcdch/image/upload/v1705837846/React30/20240117_115645_0000_kjym8j.jpg",
      description:
        "In this article, we’ll explore the process of building an image recognition app in React.",
      articleLink:
        "https://smhatre59.medium.com/react30-part30-building-an-image-recognition-app-using-tensorflowjs-3eafe0216294"
    }
  ];

  return (
    <section className="bg-gray-100 py-16">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-8">
          Lessons
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {lessons.map((lesson) => (
            <LessonCard
              key={lesson.id}
              title={lesson.title}
              image={lesson.image}
              description={lesson.description}
              articleLink={lesson.articleLink}
              id={lesson.id}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LessonsSection;
